import { useState } from "react";
import { DateRangePicker } from "../../shared/dateRangePicker";
import { SearchSelect } from "../../shared/searchSelect";
import { SearchFiltersModal } from "../../shared/searchFiltersModal";
import stringHelpers from "../../../utilities/stringHelpers";
import { toDateString } from "../../../utilities/dateUtilities";

export const AuditLogFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialFromDate,
	initialToDate,
	initialSelectedUser,
	initialEntity,
	initialAction,
	initialAppliedFilters,
	users = [],
	entities,
	actions
}) => {
	const [fromDate, setFromDate] = useState(initialFromDate)
	const [toDate, setToDate] = useState(initialToDate)
	const [selectedUser, setSelectedUser] = useState(initialSelectedUser)
	const [entity, setEntity] = useState(initialEntity)
	const [action, setAction] = useState(initialAction)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setFromDate(null)
		setToDate(null)
		setSelectedUser(null)
		setEntity(null)
		setAction("")
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ fromDate, toDate, selectedUser, entity, action, appliedFilters }) }
			showModal={ showModal }
			key="audit-log-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
					<DateRangePicker
						fromDate={ fromDate }
						toDate={ toDate }
						setDateRange={ (firstDate, lastDate, presetLabel) => {
							const isFirstDateEmpty = firstDate === null || firstDate === ""
							const isLastDateEmpty = lastDate === null || lastDate === ""
							setFromDate(isFirstDateEmpty ? null : firstDate);
							setToDate(isLastDateEmpty ? null : lastDate);
							if (!stringHelpers.isNullOrEmpty(presetLabel)) {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters.From
									delete updatedFilters.To
									updatedFilters["Date Range"] = presetLabel
									return updatedFilters
								})
							}
							else {
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (!isFirstDateEmpty && !isLastDateEmpty) {
										delete updatedFilters.From
										delete updatedFilters.To
										updatedFilters["Date Range"] = `${toDateString(new Date(firstDate))} - ${toDateString(new Date(lastDate))}`
									} else {
										if (!isFirstDateEmpty) {
											updatedFilters.From = toDateString(new Date(firstDate))
										} else {
											delete updatedFilters.From
										}
										if (!isLastDateEmpty) {
											updatedFilters.To = toDateString(new Date(lastDate))
										} else {
											delete updatedFilters.To
										}
										delete updatedFilters["Date Range"]
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						}}
						showClearOption
						hideLabel
						fullWidth
						dropdownPositionRight
					/>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">User</label>
					<SearchSelect
						defaultLabel="All"
						width="100%"
						options={ [{ value: "", label: "All" }, ...users.map(item => ({ value: item.id, label: `${item.firstName} ${item.lastName}` }))] }
						onSelect={ value => {
							if (!stringHelpers.isNullOrEmpty(value)) {
								setSelectedUser(value)
								const selectedUserObject = users.find(item => item.id === value)
								setAppliedFilters(prevState => ({ ...prevState, "User": `${selectedUserObject.firstName} ${selectedUserObject.lastName}` }))
							} else {
								setSelectedUser(null)
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters["User"]
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						} }
						selected={ !stringHelpers.isNullOrEmpty(selectedUser) ? selectedUser : null }
					/>
				</div>

				{
					entities &&
					<div className="d-flex flex-column mb-2">
						<label className="m-0 mr-2 mb-1 nowrap">Entity</label>
						<SearchSelect
							defaultLabel="All"
							width="100%"
							options={ [{ value: "", label: "All" }, ...entities.map(item => ({ value: item, label: item }))] }
							onSelect={ value => {
								if (!stringHelpers.isNullOrEmpty(value)) {
									setEntity(value)
									setAppliedFilters(prevState => ({ ...prevState, "Entity": value }))
								} else {
									setEntity(null)
									setAppliedFilters(prevState => {
										const updatedFilters = { ...prevState }
										delete updatedFilters["Entity"]
										return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
									})
								}
							} }
							selected={ !stringHelpers.isNullOrEmpty(entity) ? entity : null }
						/>
					</div>
				}

				{
					actions &&
					<div className="d-flex flex-column mb-2">
						<label className="m-0 mr-2 mb-1 nowrap">Action</label>
						<select
							id="audit-log-action-selector"
							value={ action }
							onChange={ e => {
								setAction(e.target.value)
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									if (stringHelpers.isNullOrEmpty(e.target.value)) {
										delete updatedFilters["Action"]
									} else {
										updatedFilters["Action"] = e.target.value
									}
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							} }
							className="border rounded px-2 py-1 w-100"
						>
							<option value="">All</option>
							{
								actions.map(
									item => <option key={ item } value={ item }>{ item }</option>
								)
							}
						</select>
					</div>
				}
			</div>
		</SearchFiltersModal>
	)
}
